"use client";

import React from "react";
const partnerLogos = [{
  id: 1,
  name: "Acme Corp",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/logo_acme_corp.png"
}, {
  id: 2,
  name: "Quantum Innovations",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/logo_quantum_innovations.png"
}, {
  id: 3,
  name: "Global Synergy",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/logo_global_synergy.png"
}, {
  id: 4,
  name: "Nexus Dynamics",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/logo_nexus_dynamics.png"
}, {
  id: 5,
  name: "Apex Solutions",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/logo_apex_solutions.png"
}, {
  id: 6,
  name: "Zenith Technologies",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/logo_zenith_technologies.png"
}, {
  id: 7,
  name: "Vanguard Systems",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/logo_vanguard_systems.png"
}, {
  id: 8,
  name: "Pinnacle Group",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1606552/img/logo_pinnacle_group.png"
}];
export default function PartneredWithLeaders() {
  const duplicatedLogos = [...partnerLogos, ...partnerLogos];
  return;
}